<div class="summary-container">
  <div class="summary-header d-flex justify-content-between align-items-center">
    <div>
      <span class="fw-bold" translate>ITEMS</span>: {{ cartTotalRows }}
    </div>
    <div class="text-end">
      <span class="fw-bold" translate>TOTAL</span>:
      <lib-price *ngIf="cartContents" [price]="cartContents.totalValue" [currency]="cartContents.currency"></lib-price>
    </div>
  </div>

  <div class="cart-rows">
    <div class="cart-row" *ngFor="let row of cart">
      <div *ngIf="cachedData[row.productId]">
        <div class="d-flex justify-content-between align-items-start">
          <div class="row-info cursor-pointer" (click)="clickProduct(row.productId)">
            <div class="product-name">{{ cachedData[row.productId].product?.extra?.gme?.displayName || cachedData[row.productId].product.name }}</div>
            <small class="text-muted">{{ cachedData[row.productId].product?.extra?.gme?.displayId || row.productId }}</small>
          </div>
          <div class="row-actions d-flex align-items-center">
            <lib-buy-btn [tabindex]="tabindex || undefined" [id]="row.productId" [product]="cachedData[row.productId].product"></lib-buy-btn>
            <button [tabindex]="tabindex || undefined" type="button" class="btn btn-sm btn-outline-danger btn-remove" (click)="removeRow(row)">
              <i class="fas fa-times"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <button type="button" class="btn btn-primary w-100 mt-2" [tabindex]="tabindex || undefined" routerLink="/checkout" [disabled]="disableCheckout" translate>GO_TO_CHECKOUT</button>
</div>
